import { registerModuleClicks } from "@shared/lingxi/kit";

registerModuleClicks(require("./lingxi.json"));

require("./home.less");